import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=9817a408&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=9817a408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9817a408",
  null
  
)

export default component.exports